<template>
  <DialogContent :class="[
    {
      'tw:sm:max-w-md': size === 'sm',
      'tw:sm:max-w-lg': size === 'md',
      'tw:sm:max-w-3xl': size === 'lg',
      'tw:sm:max-w-6xl': size === 'xl',
    }
  ]">
    <slot />
  </DialogContent>
</template>

<script setup lang="ts">
import {DialogContent} from "@/shadcn/components/ui/dialog";

withDefaults(defineProps<{
  size?: 'sm' | 'md' | 'lg' | 'xl'
}>(), {
  size: 'md'
});
</script>
